module.exports = {
  MLT_MAX_CHARACTERS: 1000,
};
